export const USER_ACCESS_TOKEN = 'authToken';
export const USER_REFRESH_TOKEN = 'refreshToken';
export const ERROR = 'error';
export const SUCCESS = 'success';
export const RESEND_TIMER = 60;
export const REFRESH_TOKEN_URL = 'auth/refresh/';
export const TRIAL_DAYS = 14;
export const WARNING = 'warning';
